<template>
  <div id="app" class="no-select">
    <!-- App -->
    <f7-app :params="f7params">
      <!-- Statusbar -->
      <f7-statusbar></f7-statusbar>
      <!-- Main View -->
      <f7-view class="ios-edges" id="main-view" url="/"
        :allowDuplicateUrls="true"
        :animate="true"
        :stackPages="true"
        :main="true"
        :pushState="true"
        :pushStateSeparator="pushStateSeparator"
        :iosDynamicNavbar="false"
        :iosSeparateDynamicNavbar="false"
        :iosAnimateNavbarBackIcon="false"
        :iosSwipeBackAnimateShadow="false"
        :iosSwipeBackAnimateOpacity="false"
        :iosPageLoadDelay="0">
      </f7-view>
    </f7-app>
  </div>
</template>

<script>
import lodash from 'lodash';
import { getAppToken } from '@/util/native';
import { getToken, setToken } from '@/util/token';
import router from './router';

export default {
  data() {
    return {
      pushStateSeparator: '#!',
      f7params: {
        id: 'io.framework7.lbgj',
        name: 'LBGJ',
        theme: 'ios', // auto  ios md
        routes: router,
        dialog: {
          title: '温馨提示',
          buttonOk: '确定',
          buttonCancel: '取消',
        },
      },
    };
  },
  mounted() {
    let tokenVal = getAppToken();
    const tokenH5 = getToken() || '';
    if (!lodash.isEmpty(tokenVal) && !lodash.isEqual(tokenVal, tokenH5)) {
      setToken(tokenVal);
    } else {
      tokenVal = tokenH5;
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app.vue